export class UserUtils {
    public static isLoggedIn = (tokenExpirationDate?: number) => {
        return tokenExpirationDate && tokenExpirationDate > new Date().getTime() / 1000
    }
}